// services/form-service-tracker.ts
import { FormServiceType } from './form.service'

export const registeredFormServices: FormServiceType[] = []

export function registerFormService(fs: FormServiceType) {
    if (!registeredFormServices.includes(fs)) {
        registeredFormServices.push(fs)
    }
}

export function unregisterFormService(fs: FormServiceType) {
    const index = registeredFormServices.indexOf(fs)
    if (index !== -1) {
        registeredFormServices.splice(index, 1)
    }
}

export function isAnyFormDirty(): boolean {
    return registeredFormServices.some(fs => fs.validation?.value?.$anyDirty)
}

export function destroyAllFormServices() {
    registeredFormServices.forEach(fs => fs.destroy?.())
    registeredFormServices.length = 0 // Clear the list
}
